import { useUser as useUserLib } from '@ppay/client'

import { User } from '../../../interfaces'

export const useUser = () => {
  return useUserLib<User['personal'], User['credentials']>()
}
